// 全角数字を半角数字に変換
export function toHalfWidth(str: string) {
  return str.replace(/[０-９]/g, (match) => {
    const charCode = match.charCodeAt(0) - 0xfee0
    return String.fromCharCode(charCode)
  })
}
